import Vue from 'vue'

export default {
    storeArticles(state, articlesPagination) {
        state.article_pages = articlesPagination.last_page
        articlesPagination.data.forEach((article) => {
            Vue.set(article, 'page', articlesPagination.current_page)
            this.commit('storeArticle', article)
        })
    },
    storeArticle(state, article) {
        if (article.slider) article.slider = JSON.parse(article.slider)
        const articleIndex = state.articles.findIndex(item => item.id === article.id)
        if (articleIndex === -1) {
            state.articles.push(article)
        } else {
            if (state.articles[articleIndex].page) {
                Vue.set(article, 'page', state.articles[articleIndex].page)
            }
            Vue.set(state.articles, articleIndex, article)
        }
    },
    resetNewArticle(state) {
        state.newArticle = {
            slider: [],
            public_at: new Date().toDateString()
        }
    },
    none() {
    },
    clearExcuses(state) {
        Vue.set(state, 'articles', [])
    },
}
